import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaQuoteRight } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import img1 from "../../img/testimonial.webp";
import img1 from "../../img/serviceicon.webp";
import img2 from "../../img/serviceicon.webp";

import "./style.css";

const Testimonial = () => {

  const settings = {
    dots: true,
    arrows: false,
    speed: 1200,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          infinite: true,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <section className="gauto-testimonial-area section_70">
      <Container>
        <Row>
          <Col md={12}>
            <div className="site-heading">
              <h4>Client Experiences</h4>
              <h2>What Our Safari Guests Say</h2>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <Slider className="testimonial-slider" {...settings}>

              <div className="slide">
                <div className="single-testimonial">
                  <div className="testimonial-text">
                    <p>
                      "Our safari experience was exceptional. The Land Cruiser was
                      powerful yet incredibly comfortable, and the driver’s
                      knowledge of the Serengeti made the journey unforgettable."
                    </p>
                    <div className="testimonial-meta">
                      <div className="client-image">
                        <img src={img1} alt="Client testimonial" />
                      </div>
                      <div className="client-info">
                        <h3>Daniel Thompson</h3>
                        <p>International Safari Guest</p>
                      </div>
                    </div>
                    <FaQuoteRight />
                  </div>
                </div>
              </div>

              <div className="slide">
                <div className="single-testimonial">
                  <div className="testimonial-text">
                    <p>
                      "From airport pickup to our lodge transfers, everything was
                      handled professionally. The vehicle was spotless, fully
                      equipped, and perfect for rough terrain. Highly recommended
                      for premium safari travel."
                    </p>
                    <div className="testimonial-meta">
                      <div className="client-image">
                        <img src={img2} alt="Client testimonial" />
                      </div>
                      <div className="client-info">
                        <h3>Maria Fernandez</h3>
                        <p>Luxury Travel Client</p>
                      </div>
                    </div>
                    <FaQuoteRight />
                  </div>
                </div>
              </div>

              <div className="slide">
                <div className="single-testimonial">
                  <div className="testimonial-text">
                    <p>
                      "Reliable, safe, and incredibly comfortable. The Land
                      Cruiser 70 Series handled every park road effortlessly.
                      Sher East Africa combines strength, comfort, and class in
                      every mile."
                    </p>
                    <div className="testimonial-meta">
                      <div className="client-image">
                        <img src={img1} alt="Client testimonial" />
                      </div>
                      <div className="client-info">
                        <h3>James Mwangi</h3>
                        <p>Corporate Client</p>
                      </div>
                    </div>
                    <FaQuoteRight />
                  </div>
                </div>
              </div>

            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Testimonial;
